<template>
  <section class="page-section" id="impressum">
    <div class="container">
      <div class="text-center">
        <h2 class="section-heading text-uppercase">Impressum</h2>
        <div class="col-lg-6 offset-lg-3">
          <p>Angaben gemäß § 5 TMG</p>
          <p>ProcEvolution GmbH Campus Fichtenhain 63 47807 Krefeld</p>
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <span style="font-size: larger;" class="badge bg-primary"><i class="fas fa-person"></i> Geschäftsführer</span>
              Sebastian Bos
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <span class="badge bg-primary">Kontakt</span>
              <ul>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  <span class="badge bg-primary"><i class="fas fa-phone"></i> Telefon</span>
                  <span>+49 2151 89345 09</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  <span class="badge bg-primary"><i class="fas fa-fax"></i> Fax</span>
                  <span>+49 2151 89345 99</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-center">
                  <span class="badge bg-primary"><i class="fas fa-envelope"></i> Email</span>
                  <span>info@procevolution.com</span>
                </li>
              </ul>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <span class="badge bg-primary">Registereintrag</span>
              <span>Eintragung im Registergericht: Amtsgericht Krefeld Registernummer: HRB 17480</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <span class="badge bg-primary">D-U-N-S® Nummer</span>
              <span>34-298-3446</span>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <span class="badge bg-primary">USt-IdNr</span>
              <span>DE326058471</span>
            </li>
          </ul>
        </div>
        <div>
          Urheberrechtliche Hinweise

          Die Website nutzt Bilder von Fotolia, Adobe Stock, Shutterstock, Pexels und Unsplash.

          Social Media:

          Zusätzlich gilt dieses Impressum auch für folgende ProcEvolution Social Media Profile:

          <!-- wp:list -->
          <ul class="list-group">
            <li class="list-group-item d-flex justify-content-between align-items-center">
              <div>
                <a href="https://www.linkedin.com/company/procevolution/">
                  <span><i style="font-size: 10rem;" class="fab fa-linkedin"></i></span>
                </a>
              </div>
              <div>
                <a href="https://www.facebook.com/procevolution&nbsp;">
                  <span><i style="font-size: 10rem;" class="fab fa-facebook"></i></span>
                </a>
              </div>
              <div>
                <a href="https://www.xing.com/companies/procevolutionug">
                  <span><i style="font-size: 10rem;" class="fab fa-xing"></i></span>
                </a>
              </div>
            </li>
          </ul>
          <h3>Haftungsausschluss:</h3>
          <p>Haftung für InhalteDie Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.Haftung für LinksUnser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.UrheberrechtDie durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Impressum"
}
</script>

<style scoped>

</style>
